const PROXY_HOSTS = [
  'cdn.eatzyapp.com',
  'cdn.eatsy.net',
  'res.cloudinary.com',
];

export function proxyIfCdn(url: string | null | undefined, isVideo?: boolean): string | undefined {
  if (!url) return undefined;
  try {
    const parsed = new URL(url);
    if (PROXY_HOSTS.includes(parsed.hostname)) {
      const endpoint = isVideo ? '/api/proxy/video' : '/api/proxy/image';
      return `${endpoint}?url=${encodeURIComponent(url)}`;
    }
  } catch {
  }
  return url;
}

export function useAuthenticatedMediaUrl(src: string | undefined | null): string | undefined {
  if (!src) return undefined;
  return proxyIfCdn(src) ?? src;
}

export function useAuthenticatedVideoUrl(src: string | undefined | null): string | undefined {
  if (!src) return undefined;
  return proxyIfCdn(src, true) ?? src;
}
